<template>
    <transition name="fade">
        <div v-if="isLoadingAccount  || isLoadingCheckout || isLoadingCompanions"
            class="fixed h-full w-full bg-white top-0 right-0 bottom-0 left-0 flex justify-center z-20"
            :isAccount="isLoadingAccount"
            :isCHedkout="isLoadingCheckout"
            :isCompanions="isLoadingCompanions">
            <div class="m-auto relative">
                <img src="@/assets/img/app-loader.gif">
            </div>
        </div>
    </transition>
</template>
<script>
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
export default {
    setup() {
        const store = useStore()
        const isLoadingAccount = computed( ()=> { 
            return store.state.Accounts.loading
        })
    

        const isLoadingCheckout = computed( ()=> { 
            return store.state.Checkout.loading.subscription
        })
           const isLoadingCompanions  = computed( ()=> { 
            return store.state.Checkout.loading.companions
        })

        return { isLoadingAccount, isLoadingCheckout, isLoadingCompanions  }
    },
}
</script>